<div class="p-3.5">
    <!-- Elegant Header Navigation -->
    <div class="flex items-center justify-between mb-3 px-0.5">
        <div class="flex items-center gap-0.5">
            <button type="button" (click)="showMonths($event)"
                class="flex items-center gap-1 text-sm font-extrabold text-primary hover:bg-surface px-1.5 py-1 rounded-md transition-all active:scale-95 group">
                {{ months[viewDate.getMonth()] }}
                <svg class="w-2.5 h-2.5 text-primary/40 group-hover:text-primary/70 transition-transform duration-300"
                    [class.rotate-180]="viewMode === 'months'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            <button type="button" (click)="showYears($event)"
                class="flex items-center gap-1 text-sm font-extrabold text-primary hover:bg-surface px-1.5 py-1 rounded-md transition-all active:scale-95 group">
                {{ viewDate.getFullYear() }}
                <svg class="w-2.5 h-2.5 text-primary/40 group-hover:text-primary/70 transition-transform duration-300"
                    [class.rotate-180]="viewMode === 'years'" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="4" d="M19 9l-7 7-7-7" />
                </svg>
            </button>
        </div>

        <div class="flex gap-0.5">
            <button type="button" (click)="onPrevClick($event)"
                class="p-1.5 hover:bg-surface rounded-full transition-all text-primary active:scale-90 opacity-70 hover:opacity-100">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M15 19l-7-7 7-7" />
                </svg>
            </button>
            <button type="button" (click)="onNextClick($event)"
                class="p-1.5 hover:bg-surface rounded-full transition-all text-primary active:scale-90 opacity-70 hover:opacity-100">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>
    </div>

    <!-- Days View Mode -->
    <div *ngIf="viewMode === 'days'" class="animate-content">
        <!-- Muted Weekday Labels -->
        <div class="grid grid-cols-7 mb-1.5">
            <div *ngFor="let day of weekdays"
                class="text-center text-[10px] font-bold text-muted/30 uppercase tracking-widest py-0.5">
                {{ day }}
            </div>
        </div>

        <!-- Calendar Grid with Circular Highlights -->
        <div class="grid grid-cols-7 gap-y-0 gap-x-0">
            <div *ngFor="let day of days" (click)="selectDate(day.date, $event)"
                class="aspect-square flex items-center justify-center relative group cursor-pointer rounded-full overflow-hidden">

                <!-- Selection Highlight (Solid Primary Circle) -->
                <div *ngIf="day.isSelected"
                    class="absolute h-8 w-8 rounded-full bg-primary shadow-md ring-2 ring-primary ring-offset-bg select-pop">
                </div>

                <!-- Today Indicator (Clear Tint + Stronger Border) -->
                <div *ngIf="day.isToday && !day.isSelected"
                    class="absolute h-8 w-8 rounded-full border-2 border-primary/40 bg-primary/5"></div>

                <!-- Smooth Hover Highlight (Visible on all non-selected dates) -->
                <div *ngIf="!day.isSelected"
                    class="absolute h-8 w-8 rounded-full bg-transparent group-hover:bg-primary/10 group-active:bg-primary/15 transition-all duration-200">
                </div>

                <span class="relative text-[12.5px] font-extrabold transition-all duration-300"
                    [class.text-white]="day.isSelected"
                    [class.text-primary]="!day.isSelected && (day.isCurrentMonth || day.isToday)"
                    [class.opacity-25]="!day.isCurrentMonth && !day.isToday" [class.scale-110]="day.isSelected">
                    {{ day.date.getDate() }}
                </span>
            </div>
        </div>
    </div>

    <!-- Months View Mode -->
    <div *ngIf="viewMode === 'months'" class="animate-content py-0.5">
        <div class="grid grid-cols-3 gap-1.5">
            <div *ngFor="let monthName of months; let i = index" (click)="selectMonth(i, $event)"
                class="px-1 py-3 text-center text-[11px] font-bold rounded-lg cursor-pointer transition-all hover:bg-primary/5 active:scale-95"
                [class.bg-primary]="viewDate.getMonth() === i" [class.text-white]="viewDate.getMonth() === i"
                [class.text-primary]="viewDate.getMonth() !== i">
                {{ monthName.toUpperCase().substring(0, 3) }}
            </div>
        </div>
    </div>

    <!-- Years View Mode (Scrollable) -->
    <div *ngIf="viewMode === 'years'" class="animate-content py-0.5">
        <div class="max-h-52 overflow-y-auto custom-scrollbar pr-1 -mr-1">
            <div class="grid grid-cols-3 gap-1.5">
                <div *ngFor="let yr of years" [id]="'year-' + yr" (click)="selectYear(yr, $event)"
                    class="px-1 py-3 text-center text-[11px] font-bold rounded-lg cursor-pointer transition-all hover:bg-primary/5 active:scale-95"
                    [class.bg-primary]="viewDate.getFullYear() === yr"
                    [class.text-white]="viewDate.getFullYear() === yr"
                    [class.text-primary]="viewDate.getFullYear() !== yr">
                    {{ yr }}
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Footer Actions -->
<div class="border-t border-border p-2 px-4 flex justify-between bg-surface/30 backdrop-blur-sm">
    <button type="button" (click)="clearDate($event)"
        class="text-[10px] font-extrabold text-status-danger hover:opacity-70 transition-opacity uppercase tracking-wider">
        Clear
    </button>
    <button type="button" (click)="selectToday($event)"
        class="text-[10px] font-extrabold text-primary hover:opacity-70 transition-opacity uppercase tracking-wider">
        Today
    </button>
</div>